import { inject, Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { LocalStorage } from '../services/local-storage';

@Injectable({
  providedIn: 'root'
})
export class LoginGuard implements CanActivate {
  constructor(private router: Router,
    private storage: LocalStorage
  ) {}

  canActivate(): boolean {
    const token = this.storage.getData('token');
    if (token) {
      //  If already logged in → go to user management
      this.router.navigate(['/usermanagement']);
      return false;
    }
    return true; //  Allow access if not logged in
  }
}